import React from 'react';
import { styled } from '@material-ui/core/styles';
import colors from '../../theme/colors';
import PropTypes from 'prop-types';
import MuiButton from '@material-ui/core/Button';

const colorMap = {
  primary: {
    color: colors.white,
    bg: colors.primary,
    hoverBg: colors.primaryShades[1],
  },
  secondary: {
    color: colors.white,
    bg: colors.secondary,
    hoverBg: colors.primary,
  },
  success: {
    color: colors.white,
    bg: colors.green,
    hoverBg: colors.darkGreen,
  },
  warning: {
    color: colors.white,
    bg: colors.orange,
    hoverBg: colors.darkOrange,
  },
  error: {
    color: colors.white,
    bg: colors.red,
    hoverBg: colors.darkRed,
  },
};
let noBgVariants = ['outlined', 'text'];
const StyledButton = styled(MuiButton)(({ size, color, variant, fixed }) => ({
  position: fixed ? 'fixed' : 'initial',
  bottom: fixed ? '50px' : 'initial',
  right: fixed ? '50px' : 'initial',
  padding: `0 ${size === 'large' ? 1.6 : 1}rem`,
  height: `${size === 'large' ? 3.8 : 2.3}rem`,
  border: `${
    variant === 'outlined'
      ? colorMap[color.bg]
        ? '2px solid '
        : '1px solid ' + (colorMap[color.bg] || colorMap[color].bg)
      : 0
  }`,
  background: `${noBgVariants.includes(variant) ? colors.white : colorMap[color].bg}`,
  color: `${noBgVariants.includes(variant) ? colorMap[color].bg : colorMap[color].color}`,
  borderRadius: 4,
  fontSize: `${size === 'large' ? 1.8 : 0.876}rem`,
  transition: `all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms`,
  boxShadow: `none`,
  textTransform: 'capitalize',
  fontWeight: 600,
  fontFamily: "'Urbanist'",
  '&:not([disabled])': {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${noBgVariants.includes(variant) ? '' : colorMap[color].hoverBg}`,
      color: `${noBgVariants.includes(variant) ? '' : colorMap[color].color}`,
      border: `${
        variant === 'outlined'
          ? colorMap[color.bg]
            ? '2px solid '
            : '1px solid ' + (colorMap[color.bg] || colorMap[color].bg)
          : 0
      }`,
      boxShadow: `none`,
    },
  },
  '&:disabled': {
    cursor: `not-allowed`,
  },
}));

const Button = ({ variant, size, color, type, disabled, children, ...rest }) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      color={color}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  outlined: PropTypes.bool,
  children: PropTypes.any,
  type: PropTypes.string,
};
Button.defaultProps = {
  size: 'medium',
  color: 'primary',
  variant: 'text',
  disabled: false,
  type: 'button',
};

export default Button;
